module.exports = __webpack_public_path__ + "static/img/29.b9932b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/29.png
// module id = sSno
// module chunks = 1